import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import RichText from 'components/rich-text';
import CtaButton from 'components/cta-button/cta-button';
import cn from 'classnames';
import { imageSourceBreakpoints } from 'js/breakpoints';

const imagePositions = {
  right: 'right',
  left: 'left',
};

const ImageWithTextAndBgColorBlock = ({
  heading,
  textHtml,
  backgroundColor,
  image,
  imagePosition,
  imageCaption,
  ctaButton,
}) => {
  return (
    <div
      className={cn('block_no-gap image-with-text-and-bg-color-block', {
        [`image-with-text-and-bg-color-block_image-position_${imagePosition}`]:
          imagePosition,
      })}
      style={{ backgroundColor: backgroundColor }}
    >
      <div className="image-with-text-and-bg-color-block__container">
        <div className="image-with-text-and-bg-color-block__text-container">
          {heading && (
            <h2 className="image-with-text-and-bg-color-block__heading">
              {heading}
            </h2>
          )}
          <RichText
            text={textHtml}
            className="rich-text_in-image-with-text-and-bg-color-block"
          />
          {ctaButton && (
            <div className="image-with-text-and-bg-color-block__cta-button-holder">
              <CtaButton {...ctaButton} />
            </div>
          )}
        </div>
        {image && (
          <figure className="image-with-text-and-bg-color-block__image-container">
            <Image
              {...image}
              sources={[
                { width: 382, media: imageSourceBreakpoints.xs },
                { width: 292, media: imageSourceBreakpoints.s },
                { width: 324, media: imageSourceBreakpoints.m },
                { width: 467, media: imageSourceBreakpoints.l },
              ]}
              transform="fit"
              loading="lazy"
              className="image_size_image-with-text-and-bg-color-block"
            />
            {imageCaption && (
              <figcaption className="image-with-text-and-bg-color-block__image-caption">
                {imageCaption}
              </figcaption>
            )}
          </figure>
        )}
      </div>
    </div>
  );
};

ImageWithTextAndBgColorBlock.propTypes = {
  heading: PropTypes.string,
  textHtml: PropTypes.string,
  backgroundColor: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  imageCaption: PropTypes.string,
  imagePosition: PropTypes.oneOf(Object.values(imagePositions)).isRequired,
  ctaButton: PropTypes.exact(CtaButton.propTypes),
};

export default ImageWithTextAndBgColorBlock;
